export const DEFAULT_ITEMS_PER_PAGE = 15
export const DEFAULT_STEP_SIZE = 5
